<template>
  <div
    v-if="!isBannerClosed && visible"
    class="tw-flex tw-w-full tw-items-start tw-justify-between tw-gap-3 tw-rounded-md tw-border-2 tw-p-3 tw-border-info-500 tw-bg-info-100"
    role="alert"
    :data-test-id="`${level}-level-read-only-notification-banner`"
  >
    <div class="tw-bg-info-200 tw-p-1 tw-rounded-full tw-text-info-500">
      <cl-icon-tabler-info-circle
        :data-test-id="`${level}-level-read-only-notification-banner-info-icon`"
      />
    </div>
    <div class="tw-flex-grow tw-whitespace-normal tw-break-words">
      <div
        class="tw-text-lg tw-font-semibold"
        :data-test-id="`${level}-level-read-only-notification-banner-title`"
      >
        {{ t("banner-title-read-only-role") }}
      </div>
      <div
        :data-test-id="`${level}-level-read-only-notification-banner-message`"
      >
        {{ t("banner-text-read-only-role") }}
      </div>
    </div>
    <button
      class="tw-inline-flex"
      aria-label="Close"
      @click="handleClose"
      :data-test-id="`${level}-level-read-only-notification-banner-close-button`"
    >
      <ClIconTablerX
        :data-test-id="`${level}-level-read-only-notification-banner-close-button-icon`"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { BANNER_COOKIE } from "@/constants/banner-cookie";
import { computed, ref } from "vue";
import { useCookies } from "@vueuse/integrations/useCookies";

const { t } = useI18n();
const cookies = useCookies();

const cookieKey = ref<string>(BANNER_COOKIE.READ_ONLY_ROLE_BANNER_CLOSED);

type Props = {
  level: string;
  visible?: boolean;
};
withDefaults(defineProps<Props>(), {
  visible: false,
});

const handleClose = () => {
  cookies.set(cookieKey.value, true);
};

const isBannerClosed = computed<boolean>(() => cookies.get(cookieKey.value));
</script>

<style scoped></style>
